// extracted by mini-css-extract-plugin
export default {"wrapper":"slider-button_wrapper__1Qx-G","prev":"slider-button_prev__SPQt4","next":"slider-button_next__-ppi4"};